import React, { useState } from 'react';
import { InventoryBlackIcon, WaringRound } from '@util/svgicon';
import NftDetails from './NftDetails';
import { DateTime } from 'luxon';
import Spinner from '@util/spinner';

const RightSection = ({ nftColletion, loading }) => {
    const [nftDetails, setNftDetails] = useState(null);

    return (
        <div className='w-full flex h-full p-[36px] flex-col items-start gap-[24px] rounded-[32px] bg-[#EFEFEF] overflow-auto [box-shadow:0px_4px_4px_0px_rgba(0,_0,_0,_0.25)] backdrop-filter backdrop-blur-3xl'>
             <Spinner loading={loading} text="Please wait..." />
            <div className='w-full flex flex-col items-start gap-[36px] pb-[8px] border-b border-solid border-gray'>
                <div className='w-full flex items-center gap-[8px]'>
                    <InventoryBlackIcon />
                    <p className='text-[#000] text-[32px] font-semibold leading-[32px] tracking-[-1.92px]'>Inventory</p>
                </div>
            </div>
            <div className="w-full">
                {nftDetails ?
                    <NftDetails
                        nft={nftDetails}
                        close={() => setNftDetails(null)}
                    />
                    :
                    <NftDetailsTable
                        nftColletion={nftColletion}
                        setNftDetails={setNftDetails}
                    />
                }
            </div>
        </div>
    )
}

const NftDetailsTable = ({ nftColletion, setNftDetails }) => {
    return (
        <table className="w-full">
            <thead>
                <tr>
                    <th className="text-center p-[8px]">Name</th>
                    <th className="text-center p-[8px]">Description</th>
                    <th className="text-center p-[8px]">City</th>
                    <th className="text-center p-[8px]">Timestamp</th>
                    <th className="text-center p-[8px]">Image</th>
                    <th className="text-center p-[8px]"></th>
                </tr>
            </thead>
            <tbody>
                {nftColletion.length > 0 ?
                    nftColletion?.map((nft) => (
                        <NftInventoryTableRow
                            key={nft?.content?.metadata?.name}
                            nft={nft}
                            setNftDetails={setNftDetails}
                        />
                    ))
                    :
                    <tr>
                        <td colSpan={6} className="text-center p-[8px]">No data found</td>
                    </tr>
                }
            </tbody>
        </table>
    )
}

const NftInventoryTableRow = ({ nft, setNftDetails }) => {

    const name = nft?.content?.metadata?.name;
    const description = nft?.content?.metadata?.description;
    const city = nft?.content?.metadata?.attributes?.find(attr => attr.trait_type === 'city')?.value;
    const timestamp = nft?.content?.metadata?.attributes?.find(attr => attr.trait_type === 'timestamp')?.value;
    const image = nft?.content?.links?.image
    const formattedTimestamp = typeof timestamp === 'number' ? DateTime.fromSeconds(timestamp).toFormat('yyyy-MM-dd HH:mm:ss') : '---';

    return (
        <tr>
            <td className="text-center p-[8px]">{name ? name : '---'}</td>
            <td className="text-center p-[8px]">{description ? description : '---'}</td>
            <td className="text-center p-[8px]">{city ? city : '---'}</td>
            <td className="text-center p-[8px]">{formattedTimestamp ? formattedTimestamp : '---'}</td>
            <td className="text-center p-[8px]">
                <img src={image} alt={name} className="w-[60px] h-[60px] rounded-[8px]" />
            </td>
            <td className="text-center p-[8px]">
                <button onClick={() => setNftDetails(nft)} className="bg-black text-white rounded-full flex gap-1 p-[8px]">
                    <WaringRound />
                    Details
                </button>
            </td>
        </tr>
    )
}

export default RightSection;